module.exports = "<div *ngIf=\"showLoader\">\n    <div class=\"loader\">\n        <div class=\"line-spinner\"></div>\n    </div>\n</div>\n"